exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-icons[data-v-3b449c59]{font-size:21px}", ""]);

// exports
